module.exports = __webpack_public_path__ + "static/1-85347f7f7ed67838647a9d76eb312f39.jpg";